import React from 'react';

interface RiskLevel {
  title: string;
  description: string;
}

const riskLevels: RiskLevel[] = [
  {
    title: "Very Conservative (1)",
    description: "Focuses on preserving capital with minimal risk tolerance. Suitable for short-term investors or those near retirement."
  },
  {
    title: "Conservative (2)", 
    description: "Emphasizes capital preservation with some growth potential. Appropriate for investors with low risk tolerance."
  },
  {
    title: "Moderate (3)",
    description: "Balances growth and security. Ideal for medium-term investors comfortable with market fluctuations."
  },
  {
    title: "Growth (4)",
    description: "Prioritizes long-term growth with higher risk tolerance. Suitable for investors comfortable with market volatility."
  },
  {
    title: "Aggressive (5)",
    description: "Maximizes growth potential with highest risk tolerance. Appropriate for long-term investors comfortable with significant market swings."
  }
];

export const RiskProfileDetails = () => {
  return (
    <div className="space-y-6">
      <div className="text-gray-800">
        The AltsIQ Risk Score is a proprietary measure that evaluates your portfolio's risk level on a scale from 1 to 5, based on your asset allocation strategy. This score helps you understand and manage your investment risk exposure.
      </div>
      <div className="text-sm text-gray-500 italic">
        Note: The risk level indicators may display differently across browsers. This is a known issue being investigated.
      </div>
      {riskLevels.map((risk, index) => (
        <div key={index} className="p-4 bg-gray-50 rounded-lg">
          <div className="flex flex-col gap-2">
            <div className="font-semibold text-navy">
              {risk.title}
            </div>
            <p className="text-gray-600">
              {risk.description}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default RiskProfileDetails;